/**
 * Per-state registration term defaults for the Fees request.
 *
 * Used only when the form has no explicit registration term. Oregon registers
 * passenger vehicles on a 2-year cycle, so a 12-month term understates every
 * registration-scaled fee there — the Oregon Registration Fee and the county fee
 * ATC labels "Misc County Fees". Any state not listed falls back to 12, which is
 * the CULS Fees API documented default.
 *
 * This must stay in sync with STATE_REGISTRATION_MONTHS in both
 *   ATC_Flask/fees.py
 *   DMV-bot-fees/lambda_function.py
 * or the bot and the web app will quote different registration fees for the same
 * vehicle. tests/fees/test_fee_request_parity.py guards the two Python copies.
 *
 * Keyed on both the abbreviation and the full name because the state value on the
 * Fees form comes from ATC's zipcodeinfo response and can be either form — the
 * same ambiguity getRequiredMpgFieldsForState() already handles.
 */
export const STATE_REGISTRATION_MONTHS = {
  OR: '24',
  OREGON: '24',
};

export const DEFAULT_REGISTRATION_MONTHS = '12';

/**
 * The registration term to send when the user hasn't specified one.
 *
 * @param {string} state - state abbreviation or full name, any case.
 * @returns {string} months, as a string, ready for the request payload.
 */
export const getDefaultRegistrationMonths = (state) => {
  const key = String(state || '').trim().toUpperCase();
  return STATE_REGISTRATION_MONTHS[key] || DEFAULT_REGISTRATION_MONTHS;
};
